"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringUtils_1 = require("./helpers/stringUtils");
exports.buildURL = function (q) {
    return Object.entries(q)
        .filter(function (_a) {
        var v = _a[1];
        return Boolean(v);
    })
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        return [stringUtils_1.toUnderscore(k), stringUtils_1.spaceToPlus("" + v)];
    })
        .sort(function (_a, _b) {
        var k1 = _a[0];
        var k2 = _b[0];
        return k1.localeCompare(k2);
    })
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        return k + "=" + v;
    })
        .join('&');
};
//# sourceMappingURL=builder.js.map